/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarSupplyPlan = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 4V2h2v2h6V2h2v2h5v7h-2V6h-3v2h-2V6H9v2H7V6H4v14h7v2H2V4zm5.707 6.707L8 15.414l-2.707-2.707 1.414-1.414L8 12.586l3.293-3.293zm5.823 1.445a1 1 0 0 0-1.06 0l-4 2.5a1 1 0 0 0-.47.848v4a1 1 0 0 0 .47.848l4 2.5a1 1 0 0 0 1.06 0l4-2.5A1 1 0 0 0 23 19.5v-4a1 1 0 0 0-.47-.848zM17 18.554v1.642l-2-1.25v-1.642zm4-1.25v1.642l-2 1.25v-1.642zm-.887-1.804L18 16.82l-2.113-1.32L18 14.18z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCalendarSupplyPlan as CalendarSupplyPlan };
